import {
  DocumentationItemConfigurationV2,
  DocumentationItemHeaderAlignment,
  DocumentationItemHeaderImageScaleType,
} from "@supernova-studio/model";
import { DTODocumentationItemConfigurationV2 } from "../../dto/elements/documentation/item-configuration-v2";

export const getDtoDefaultItemConfigurationV2 = () =>
  ({
    showSidebar: true,
    isHidden: false,
    isPrivate: false,
    header: {
      alignment: DocumentationItemHeaderAlignment.Left,
      backgroundImageScaleType: DocumentationItemHeaderImageScaleType.AspectFill,
      description: "",
      showBackgroundOverlay: false,
      showCoverText: true,
    },
  } as const);

export function documentationItemConfigurationToDTOV2(
  config: DocumentationItemConfigurationV2 | undefined
): DTODocumentationItemConfigurationV2 {
  const dtoDefaultItemConfigurationV2 = getDtoDefaultItemConfigurationV2();
  if (!config) return dtoDefaultItemConfigurationV2;

  return {
    header: config.header,
    isHidden: config.isHidden ?? dtoDefaultItemConfigurationV2.isHidden,
    isPrivate: config.isPrivate ?? dtoDefaultItemConfigurationV2.isPrivate,
    showSidebar: config.showSidebar,
  };
}
